import React from 'react';
import { useDataMaps } from 'new/hooks/adapters/useDataMaps';
import ConfigureAPI from 'js/components/data_sources/add_ds_form/ConfigureAPI';
import useApp from 'new/state/app/repository/useApp';
import { useRestAPIContext } from 'new/components/flows/configure/RestAPISource/RestAPISourceProvider';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';

export function RestAPISource({ showExternalTrigger }: { showExternalTrigger?: boolean }) {
  const [state, actions] = useRestAPIContext();

  const {
    meta,
    paging,
    isLoadingDataMaps,
    advancedFields,
    visibleFields,
    apiResponseByStage,
    apiResponseUpdateTime,
    isLoadingProbeSample,
    dataPathValidationResultByStage,
    apiConfig,
    sourceConfig,
    selectedConnection,
  } = state;

  const ctx = useApp();
  const { data } = useFlowsSetup(state.formType, state.flowType);
  const { dataMaps, dataMapSamples, fetchDataMaps } = useDataMaps();

  const onInputChange = ({ property, value }) => {
    actions.onSourceConfigChanged({
      ...apiConfig,
      [property]: value,
    });
  };

  return (
    <ConfigureAPI
      paging={paging}
      apiConfig={apiConfig}
      dataMaps={dataMaps}
      onInputChange={onInputChange}
      dataMapSamples={dataMapSamples}
      advancedFields={advancedFields}
      selectedConnectionDetails={meta}
      visibleFieldData={visibleFields}
      sourceName={apiConfig?.sourceName}
      sourceDescription={apiConfig?.sourceDescription}
      isLoadingDataMaps={isLoadingDataMaps}
      selectedConnection={selectedConnection}
      flowType={state.flowType}
      isLoadingProbeSample={isLoadingProbeSample}
      apiResponseByStage={apiResponseByStage}
      apiResponseUpdateTime={apiResponseUpdateTime}
      dataPathValidationResultByStage={dataPathValidationResultByStage}
      sourceBeingEdited={data?.source}
      showExternalTrigger={showExternalTrigger}
      // actions
      setFormError={actions.showError}
      onAddStep={actions.onAddStep}
      onRemoveStep={actions.onRemoveStep}
      loadDataMaps={fetchDataMaps}
      validateDataPath={actions.onValidateDataPath}
      onSourceConfigChanged={actions.onSourceConfigChanged}
      onGetParameterizedURLs={actions.onGetParameterizedURLs}
      onCallAPI={actions.onProbeGetSample}
      onClearAPIResponse={actions.onProbeClearSample}
      onAPIConfigChanged={actions.onAPIConfigChanged}
      setContextualSupport={ctx.setContextualSupport}
      unsetContextualSupport={ctx.unsetContextualSupport}
      onSaveAdvancedMode={actions?.onSaveAdvancedMode}
      onSwitchUiMode={actions?.onSwitchUiMode}
      nextFormStage={actions?.nextFormStage}
      goBack={actions?.goBack}
      onError={actions?.onError}
    />
  );
}
